import { memo, useEffect, useState, useRef } from "react"

import ProductService from "@/services/product"
import { Stack, Text, Image, AspectRatio, Center, Button, Container, Box, Table, IconButton, Input, Card, VStack, HStack } from "@chakra-ui/react"
import { useCart } from "contexts/cart"
import { formatCurrency } from "@/utilities/number"
import { LuPencil } from "react-icons/lu"
import {
    DrawerBackdrop,
    DrawerBody,
    DrawerCloseTrigger,
    DrawerContent,
    DrawerFooter,
    DrawerHeader,
    DrawerRoot,
    DrawerTitle,
    DrawerTrigger,
    DrawerActionTrigger
} from "@/components/ui/drawer"
import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"

import OrderService from "services/order"
import { useParams } from "react-router"
const service = new OrderService();

const Cart = () => {
    const { setProcessing, setPageTitle, showToast } = useApp();

    const [order, setOrder] = useState({})
    const { id } = useParams();
    console.log("id", id);

    useEffect(() => {
        setPageTitle("Hoàn tất")
    }, [setPageTitle])

    useEffect(() => {
        loadData();

    }, [id])

    const loadData = async () => {
        var data = await service.get(id);
        if (data) {
            setOrder(data);
        }
    }












    const downloadPDF = async () => {
        try {
            var url = order.invoice_file;
            var filename = order.id + ".pdf";
            // Fetch the PDF data as a Blob
            const response = await fetch(url);
            const blob = await response.blob();

            // Create a download link and set its attributes
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;

            // Append the link to the document, click it, and remove it
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error while downloading PDF:', error);
        }
    }


    const downLoadInvoiceFile = async () => {
        setProcessing(true)
        var data = await service.createInvoiceFile({ id: order.id });
        setProcessing(false);
        if (data) {

            window.location =  data.invoice_file;
        }

    }




    return (
        <div style={{ paddingBottom: 75 }}>

            <div >


                <Stack gap="4" align="flex-start" maxW="sm">


                    <Center>
                        <Image src="https://storage.googleapis.com/cubebio/default/confirmed.svg" style={{ maxWidth: "50%" }}></Image>

                    </Center>

                    <Center>

                        Chân thành cảm ơn bạn đã tin tưởng và chọn sản phẩm của chúng tôi.


                    </Center>






                    <Center>

                        Qúy khách vui lòng check kỹ bill hàng và thanh toán qua STK: 0911575968 MB bank chi nhánh Đà Lạt - Lâm Đồng,

                    </Center>
                    <Center>

                        Sau đó chụp màn hình gửi qua zalo 0911575968 để nhân viên đóng hàng và chuyển hàng sớm nhất đến quý khách


                    </Center>
                    <VStack>
                        <Button onClick={downLoadInvoiceFile}>Tải xuống hoá đơn</Button>
                        <Button onClick={downLoadInvoiceFile}>Thanh toán</Button>
                        <Button onClick={downLoadInvoiceFile}>Quản lý đơn hàng</Button>
                    </VStack>

                    <Center>
                        Xin chân thành cám ơn và rất hân hạnh phục vụ quý khách.
                    </Center>






                </Stack>



            </div>



        </div >
    )
}


export default memo(Cart)